<!-- 
  Mobile Nav Trigger:
  This button updates the state to enable/disable the mobile nav
-->

<template>
  <div style-max-size="medium" class="site-mobile-nav__trigger" @click="toggle()" v-bind:class="{ 'is-active': state.mobileNavActive }">
    <div class="icon"></div>
  </div>
</template>

<script>
  export default {
    name: 'MobileNavTrigger',
    data(){
      return {
        // Get the state from the global store.
        state: store.state,
      }
    },
    methods: {
      // Toggle method to update the state.
      toggle: function() {
        if (!this.state.mobileNavActive) {
          store.enableMobileNav();
        } else {
          store.disableMobileNav();
        }
      },
    },
  }
</script>